var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckedSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#067BC2",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M7.109 11.517l6.436-6.274a.857.857 0 1 1 1.196 1.228l-7.034 6.857a.857.857 0 0 1-1.197 0l-3.251-3.17a.857.857 0 0 1 1.196-1.227l2.654 2.586z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckedSmall);
export default __webpack_public_path__ + "static/media/icon_checked_small.2856788232647610cc5ce388791fec5f.svg";
export { ForwardRef as ReactComponent };